import { AuthenticationProvider } from 'main/auth/provider';

export const createDownloadFileFormOnClick = (
	token: string,
	url = '',
	name = '',
	formData: object = {}
) => {
	const form = document.createElement('form');
	document.body.appendChild(form);
	form.setAttribute(
		'action',
		`${url}${url.includes('?') ? '&' : '?'}AuthType=FileDownload`
	);
	form.setAttribute('type', 'hidden');
	form.setAttribute('target', '_blank');
	form.setAttribute('method', 'post');
	form.setAttribute('name', name);
	const body = document.createElement('input');
	body.setAttribute('type', 'hidden');
	body.setAttribute('name', 'token');
	body.setAttribute('value', token);
	form.appendChild(body);

	for (const param of Object.entries(formData)) {
		let inputValue = '';
		if (param[1] instanceof Date) {
			inputValue = param[1].toISOString();
		} else if (param[1] != null) {
			inputValue = param[1].toString();
		}

		const elem = document.createElement('input');
		elem.setAttribute('type', 'text');
		elem.setAttribute('name', param[0]);
		elem.setAttribute('value', inputValue);
		form.appendChild(elem);
	}

	form.submit();
	form.removeChild(body);
	document.body.removeChild(form);
};

export const isBlob = (url: string) => url.includes('blob');

export const onDownloadLinkClick =
	(
		provider: AuthenticationProvider,
		url: string | undefined,
		trimmedFilename: string
	) =>
	async (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
		if (!isBlob(url || '')) {
			event.preventDefault();
			createDownloadFileFormOnClick(
				await provider.getTokenAsync(),
				url,
				trimmedFilename
			);
		}
	};
